
import { defineStore } from "pinia";
import { Local } from '@/utils/storage'
import { getAdminPermissions,getFeatureTrialUsage,getAdminChamber,getAdminChamberPermissions } from '@/api'

export const useSystemStore = defineStore("system", {
    state: () => {
        return {
            admin_name: Local.get("managerInfo")?.nickname || '登录',
            current_mechanism: Local.get("current_mechanism") || {},
            mechanism_list: Local.get("mechanism_list") || [],
            categories_list: [],
            area_list: [],
            permissionCodes: Local.get('permissionCodes') || [],
            trialCount: {}
        }
    },
    actions: {
        getTrialUsage(){
            getFeatureTrialUsage().then((res: any)=>{
                let map: EmptyObjectType = {}
                res.data.forEach((item: EmptyObjectType)=>{
                    map[item.feature_code] = item.talent_count
                })
                this.trialCount = map
            })
        },

        getPermissions() {
            if (!Local.get("managerInfo")) {
                return
            }
            let permissionCodes = Local.get('permissionCodes')
            if (!permissionCodes) {
                getAdminPermissions().then((res:any) => {
                     // 更新本地存储的权限
                     Local.set("permissions", res.data);
                     Local.set("permissionCodes", res.data);
              
                     // 更新store中的权限
                     this.permissionCodes = res.data;
                    
                })
            }

        },
        getManagerChamber(){
            if (!Local.get("managerInfo")) {
                return
            }
            const promise = getAdminChamber()
            if (!promise) {
                return
            }
            promise.then((res:any) => {
                let list = res.data || []
                let cham = Local.get('curChamber')
                if(cham.chamber_id == 0){
                    Local.set('chambers',list)
                    return
                }
                
                if(cham.chamber_id){
                    let curChamber = list.find((item:any) => item.chamber_id == cham.chamber_id)
                    if(curChamber){
                        Local.set('curChamber',curChamber)
                    }else{
                        Local.set('curChamber',list[0] || {})
                    }
                    Local.set('chambers',list)
                }else{
                    Local.set('curChamber',list[0] || {})
                    Local.set('chambers',list)
                }
                
            })
        },

        // 获取商会权限并刷新页面
        async getChamberPermissionsAndRefresh(chamber: any) {
            const managerInfo = Local.get("managerInfo");
            if (!managerInfo || !chamber.position_id) {
                location.reload();
                return;
            }

            try {
                // 调用接口获取新商会的权限
                const res: any = await getAdminChamberPermissions({
                    id: chamber.position_id,
                    userId: managerInfo.id
                });

                if (res && res.data) {
                    // 更新本地存储的权限
                    Local.set("permissions", res.data);
                    Local.set("permissionCodes", res.data);
             
                    // 更新store中的权限
                    this.permissionCodes = res.data;
                }

                // 获取权限后刷新页面
                location.reload();
            } catch (error) {
                console.error('获取商会权限失败:', error);
                // 即使失败也刷新页面
                location.reload();
            }
        }
    }
})
